(function($){
  $(function(){
    //PCのとき 電話番号 無効
    if($(window).innerWidth() > 768){
      $(".-telink").on('click', function(){
        return false;
      });
    }else{}

    var getTranslate;
    var slideWidth;
    
    //swiper
    const wrapper = document.querySelector('.custom-ranking .swiper-wrapper');
    const slides = Array.from(wrapper.children);
    // 複製してappend（2倍に）
    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      wrapper.appendChild(clone);
    });
    var storeSlide = new Swiper('.custom-ranking',{
      loop: true,
      slidesPerView: 1,
      //speed: 1200,
      speed: 6800,
      spaceBetween: 24,
      slideToClickedSlide: true,
      watchSlidesVisibility: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        641: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1300: {
          slidesPerView: 4.5,
        }
      }
  });
    // $(window).on('resize',function(){
    //   storeSlide.autoplay.paused = false;
    // });
    $(window).on('resize', function () {
      storeSlide.autoplay.start();
    });
  });

  $(window).on('load', function(){
    refresh_subtotal();
  });
  function refresh_subtotal(){
    var price = $('.subtotal-price').text();
    var rmtxt = price.replace(/,|¥/g, '');
    var result = rmtxt * 1.1;
    var pricetax = Math.floor(result);
    var pricesimulate = pricetax.toLocaleString();
    $('#pricesimulate').text("¥" + pricesimulate + "（税込）");
    setTimeout(function(){
      refresh_subtotal();
    },500);
  }

  //attention modal
  $(document).ready(function () {
    const hasClicked = sessionStorage.getItem('attentionPopupClicked');
    if (!hasClicked) {
      $('.attention-popup-modal').fadeIn();
    } else {
      $('.attention-popup-modal').hide();
    }
    // 閉じるボタンをクリックしたとき、以降表示しないようにフラグを保存
    $('.attention-popup-btn, .attention-popup-close').on('click', function () {
      sessionStorage.setItem('attentionPopupClicked', 'true');
      $(this).closest('.attention-popup-modal').fadeOut();
    });
  });

})(jQuery);